import React, { PureComponent } from "react";

import Dashboard from "../../routes/dashboard/Dashboard";
import Role from "../../routes/role/Role";
import Country from "../../routes/country/Country";
import News from "../../routes/news/News";
import Settings from "../../routes/settings/Settings";

import "./Navigation.scss";
import Content from "../app-layout/Content";
import ATGDashboard from "../../routes/atg-dashboard/ATGDashboard";
import PolicyDashboard from "../../routes/policies/PolicyDashboard";
import Info from "../../routes/info/Info";

const DASHBOARD = 3;
const COUNTRY = 4;
const ROLE = 5;
const NEWS = 6;
const POLICY = 7;
const SETTINGS = 8;
const INFO = 9;
const LINKS = 10;

export default class Navigation extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: DASHBOARD,
      isGameComplete: false,
      updateDashboard: false,
    };
    this.isDelegate = this.props.roleName.includes("ATG");
  }

  setContent = (e, nav) => {
    e.preventDefault();

    if (nav.content === LINKS) {
      window.open(nav.href, "_blank");
    } else {
      this.setState({ selected: nav.content });
    }
  };

  onCb = () => {
    this.props.cb();
    this.setState(() => ({
      updateDashboard: true,
    }));
  };

  componentDidUpdate = () => {
    this.setState(() => ({
      updateDashboard: false,
    }));
  };

  showNewsArticleCb = () => {
    this.setState({ selected: NEWS });
  };

  render() {
    const navLinks = [
      {
        name: "Dashboard",
        href: "/dashboard",
        icon: "iconDashboard",
        content: DASHBOARD,
      },
      {
        name: "Policies",
        href: "/policies",
        icon: "iconPolicies",
        content: POLICY,
      },
      {
        name: "News & Updates",
        href: "/news",
        icon: "iconNews",
        content: NEWS,
      },
      {
        name: "Role Info",
        href: "/role_wiki",
        icon: "iconRole",
        content: ROLE,
      },
      {
        name: "Country Info",
        href: "/country_wiki",
        icon: "iconWorld",
        content: COUNTRY,
      },
      {
        name: "Settings",
        href: "/settings",
        icon: "iconSettings",
        content: SETTINGS,
      },
      {
        name: "Documentation",
        href: "/info",
        icon: "iconInfo",
        content: INFO,
      },
      // {
      //     name: 'Frank Batten School',
      //     href: 'https://batten.virginia.edu',
      //     icon: 'iconBatten',
      //     content: LINKS,
      // },
      // {
      //     name: 'CLSG',
      //     href: 'https://www.clsgbatten.org',
      //     icon: 'iconClsg',
      //     content: LINKS,
      // },
    ];

    return (
      <div>
        <div className="nav__wrap">
          <ul className="nav__list">
            {navLinks.map((nav, index) => {
              return (
                <li key={index}>
                  <button onClick={(e) => this.setContent(e, nav)}>
                    <span className={`nav__icon ${nav.icon}`} />
                    <span className="nav__link">{nav.name}</span>
                    <span className="nav__border" />
                  </button>
                </li>
              );
            })}
          </ul>
        </div>

        <Content>
          {this.isDelegate ? (
            <ATGDashboard
              display={this.state.selected === DASHBOARD ? "show" : ""}
              updateDashboard={this.state.updateDashboard}
            />
          ) : (
            <Dashboard
              display={this.state.selected === DASHBOARD ? "show" : ""}
              isGameComplete={this.state.isGameComplete}
              updateDashboard={this.state.updateDashboard}
            />
          )}

          <Country display={this.state.selected === COUNTRY ? "show" : ""} />

          <Role
            isDelegate={this.isDelegate}
            display={this.state.selected === ROLE ? "show" : ""}
          />

          <PolicyDashboard
            isDelegate={this.isDelegate}
            display={this.state.selected === POLICY ? "show" : ""}
            roleName={this.props.roleName}
            polTime={this.props.polTime}
            cb={this.onCb}
            onGameComplete={(val) => {
              return this.setState({ isGameComplete: val });
            }}
            showNewsArticleCb={this.showNewsArticleCb}
            std={this.props.std}
          />

          <News
            display={this.state.selected === NEWS ? "show" : ""}
            polTime={this.props.polTime}
          />

          <Settings
            display={this.state.selected === SETTINGS ? "show" : ""}
            isGameComplete={this.state.isGameComplete}
          />

          <Info display={this.state.selected === INFO ? "show" : ""} />
        </Content>
      </div>
    );
  }
}
